import { FITNESS_PAGE_ROUTES, TOP_LEVEL_ROUTES } from './routes';

export const pageKey = {
	// Home
	home: 'home',

	// Member Management
	memberEligibilitySearch: 'member-eligibility-search',
	memberTerminationReport: 'member-termination-report',

	// Account
	accountManagement: 'account-management',
	confirmUpdateInformation: 'confirm-update-information',
	providerValidation: 'ProviderValidation',
	messageCenter: 'message-center',
	createSubAccount: 'create-sub-account',
	editSubAccounts: 'edit-sub-accounts',
	manageSubAccounts: 'manage-sub-accounts',
	transactionSummary: 'transaction-summary',
	favoriteCPTCode: 'favorite-cpt-code',
	activitySummary: 'ActivitySummary',
	updateInfo: 'update-info',
	practitionerStatusChangeRequest: 'PractitionerStatusChangeRequest',
	practitionerValidation: 'PractitionerValidation',

	// Resources
	clientSummary: 'client-summary',
	fitnessInstructorServiceAgreement: 'fitness-instructor-service-agreement',
	fitnessServicesAgreement: 'fitness-services-agreement',
	notification: 'notification',
	programEducationLibrary: 'program-education-library',
	programManual: 'program-manual',
	forms: 'resources-form',

	// Billing and Payment
	claimsAndPayments: 'claim-and-payment',
	memberBillingReport: 'member-billing-report',
	bulkClaimSummary: 'bulk-claim-summary',
	bulkClaimUpload: 'bulk-claim-upload',

	// Help
	ASHLinkWebsiteTip: 'ashlink-website-tip',
	contactUs: 'contact-us',
	frequentlyAskedQuestion: 'frequently-asked-question',
	submitAnOnlineQuestionOrComment: 'submit-question-or-comment',

	// Welcome Packet
	welcomePacket: 'welcome-packet',

	// Footer
	privacyStatement: 'privacy-statement',
	termsAndCondition: 'terms-and-condition',
	memberAgreements: 'member-agreements',

	// Identity
	identity: 'identity',

	switchLocation: 'switch-location',
	confirmLocation: 'confirm-location',

	logOut: 'log-out',
};

export const permissionName = {
	// General
	general: 'General',

	// Member Management
	memberEligibilitySearch: 'MemberEligibilitySearch',
	memberTerminationReport: 'MemberTerminationReport',

	// Account
	fitnessInstructorInformationValidation:
		'FitnessInstructorInformationValidation',
	fitnessCenterInformationValidation: 'FitnessCenterInformationValidation',
	generalUserInformation: 'GeneralUserInformation',
	linkedUser: 'LinkedUser',
	messageCenter: 'MessageCenter',
	favoriteCPTCode: 'FavoriteCPTCode',

	// Resources
	clientSummary: 'ClientSummary',
	form: 'Form',
	fitnessInstructorServiceAgreement: 'FitnessInstructorServiceAgreement',
	fitnessServicesAgreement: 'FitnessServicesAgreement',
	notification: 'Notification',
	programEducationLibrary: 'ProgramEducationLibrary',
	programManual: 'ProgramManual',

	// Billing and Payments
	bulkClaim: 'BulkClaim',
	claim: 'Claim',
	memberBillingReport: 'MemberBillingReport',
	payment: 'Payment',

	// Welcome Packet
	welcomePacket: 'WelcomePacket',

	// Help menu items
	help: 'Help',
};

export const permissionOperation = {
	read: 'Read',
	createUpdate: 'CreateUpdate',
	delete: 'Delete',
};

export const retrievePermissionWithKey = {
	// Home
	[`${pageKey.home}`]: `${permissionName.general}:${permissionOperation.read}`,

	// Member Management
	[`${pageKey.memberEligibilitySearch}`]: `${permissionName.memberEligibilitySearch}:${permissionOperation.read}`,
	[`${pageKey.memberTerminationReport}`]: `${permissionName.memberTerminationReport}:${permissionOperation.read}`,

	[`${pageKey.accountManagement}`]: `${permissionName.generalUserInformation}:${permissionOperation.read}`,
	[`${pageKey.confirmUpdateInformation}`]: [
		`${permissionName.practitionerValidation}:${permissionOperation.createUpdate}`,
		`${permissionName.providerValidation}:${permissionOperation.createUpdate}`,
	],
	[`${pageKey.messageCenter}`]: `${permissionName.messageCenter}:${permissionOperation.read}`,
	[`${pageKey.createSubAccount}`]: `${permissionName.linkedUser}:${permissionOperation.createUpdate}`,
	[`${pageKey.manageSubAccounts}`]: `${permissionName.linkedUser}:${permissionOperation.read}`,
	[`${pageKey.editSubAccounts}`]: `${permissionName.linkedUser}:${permissionOperation.createUpdate}`,
	[`${pageKey.favoriteCPTCode}`]: `${permissionName.favoriteCPTCode}:${permissionOperation.read}`,
	[`${pageKey.updateInfo}`]: `${permissionName.ASHCareSSO}:${permissionOperation.read}`, // TODO
	[`${pageKey.transactionSummary}`]: `${permissionName.activitySummary}:${permissionOperation.read}`,
	[`${pageKey.practitionerStatusChangeRequest}`]: `${permissionName.practitionerStatusChangeRequest}:${permissionOperation.read}`,

	// Resources
	[`${pageKey.clientSummary}`]: `${permissionName.clientSummary}:${permissionOperation.read}`,
	[`${pageKey.fitnessInstructorServiceAgreement}`]: `${permissionName.fitnessInstructorServiceAgreement}:${permissionOperation.read}`,
	[`${pageKey.fitnessServicesAgreement}`]: `${permissionName.fitnessServicesAgreement}:${permissionOperation.read}`,
	[`${pageKey.forms}`]: `${permissionName.form}:${permissionOperation.read}`,
	[`${pageKey.notification}`]: `${permissionName.notification}:${permissionOperation.read}`,
	[`${pageKey.programEducationLibrary}`]: `${permissionName.programEducationLibrary}:${permissionOperation.read}`,
	[`${pageKey.programManual}`]: `${permissionName.programManual}:${permissionOperation.read}`,

	// Billing and Payment
	[`${pageKey.bulkClaimSummary}`]: `${permissionName.bulkClaim}:${permissionOperation.read}`,
	[`${pageKey.bulkClaimUpload}`]: `${permissionName.bulkClaim}:${permissionOperation.createUpdate}`,
	[`${pageKey.claimsAndPayments}`]: [
		`${permissionName.claim}:${permissionOperation.read}`,
		`${permissionName.payment}:${permissionOperation.read}`,
	],
	[`${pageKey.memberBillingReport}`]: `${permissionName.memberBillingReport}:${permissionOperation.read}`,

	// Help
	[`${pageKey.ASHLinkWebsiteTip}`]: `${permissionName.help}:${permissionOperation.read}`,
	[`${pageKey.contactUs}`]: `${permissionName.help}:${permissionOperation.read}`,
	[`${pageKey.frequentlyAskedQuestion}`]: `${permissionName.help}:${permissionOperation.read}`,
	[`${pageKey.submitAnOnlineQuestionOrComment}`]: `${permissionName.messageCenter}:${permissionOperation.createUpdate}`,

	// Welcome Packet
	[`${pageKey.welcomePacket}`]: `${permissionName.welcomePacket}:${permissionOperation.read}`,

	// Footer
	[`${pageKey.termsAndCondition}`]: `${permissionName.general}:${permissionOperation.read}`,
	[`${pageKey.privacyStatement}`]: `${permissionName.general}:${permissionOperation.read}`,
	[`${pageKey.memberAgreements}`]: `${permissionName.general}:${permissionOperation.read}`,

	// Identity
	[`${pageKey.identity}`]: `${permissionName.general}:${permissionOperation.read}`,

	[`${pageKey.confirmLocation}`]: `${permissionName.general}:${permissionOperation.read}`,
	[`${pageKey.switchLocation}`]: `${permissionName.general}:${permissionOperation.read}`,
};

export const retrievePageKeyWithRoute = {
	// Account
	[`/${TOP_LEVEL_ROUTES.account}/${FITNESS_PAGE_ROUTES.accountManagement}`.toLowerCase()]:
		pageKey.accountManagement,
	[`/${TOP_LEVEL_ROUTES.account}/${FITNESS_PAGE_ROUTES.createSubAccount}`.toLowerCase()]:
		pageKey.createSubAccount,
	[`/${TOP_LEVEL_ROUTES.account}/${FITNESS_PAGE_ROUTES.manageSubAccounts}`.toLowerCase()]:
		pageKey.manageSubAccounts,
	[`/${TOP_LEVEL_ROUTES.account}/${FITNESS_PAGE_ROUTES.editSubAccounts}`.toLowerCase()]:
		pageKey.editSubAccounts,

	// Resources
	[`/${TOP_LEVEL_ROUTES.resources}/${FITNESS_PAGE_ROUTES.clientSummaries}`.toLowerCase()]:
		pageKey.clientSummary,
	[`/${TOP_LEVEL_ROUTES.resources}/${FITNESS_PAGE_ROUTES.fitnessInstructorServicesAgreements}`.toLowerCase()]:
		pageKey.fitnessInstructorServiceAgreement,
	[`/${TOP_LEVEL_ROUTES.resources}/${FITNESS_PAGE_ROUTES.fitnessServicesAgreement}`.toLowerCase()]:
		pageKey.fitnessServicesAgreement,
	[`/${TOP_LEVEL_ROUTES.resources}/${FITNESS_PAGE_ROUTES.forms}`.toLowerCase()]:
		pageKey.forms,
	[`/${TOP_LEVEL_ROUTES.resources}/${FITNESS_PAGE_ROUTES.notifications}`.toLowerCase()]:
		pageKey.notification,
	[`/${TOP_LEVEL_ROUTES.resources}/${FITNESS_PAGE_ROUTES.programEducationLibrary}`.toLowerCase()]:
		pageKey.programEducationLibrary,
	[`/${TOP_LEVEL_ROUTES.resources}/${FITNESS_PAGE_ROUTES.programManual}`.toLowerCase()]:
		pageKey.programManual,

	// Help
	[`/${TOP_LEVEL_ROUTES.help}/${FITNESS_PAGE_ROUTES.faq}`.toLowerCase()]:
		pageKey.frequentlyAskedQuestion,

	// Welcome Packet
	[`/${TOP_LEVEL_ROUTES.welcomePacket}`.toLowerCase()]: pageKey.welcomePacket,
	[`/${TOP_LEVEL_ROUTES.memberAgreements}`.toLowerCase()]:
		pageKey.memberAgreements,
	[`/${TOP_LEVEL_ROUTES.privacyStatement}`.toLowerCase()]:
		pageKey.privacyStatement,
	[`/${TOP_LEVEL_ROUTES.termsAndConditions}`.toLowerCase()]:
		pageKey.termsAndCondition,

	[`/${TOP_LEVEL_ROUTES.confirmLocation}`.toLowerCase()]:
		pageKey.confirmLocation,
	[`/${TOP_LEVEL_ROUTES.switchLocation}`.toLowerCase()]:
		pageKey.switchLocation,

	// Identity
	[`/${TOP_LEVEL_ROUTES.identity}`.toLowerCase()]: pageKey.identity,

	// Home
	'/': pageKey.home,
};
